import { render, staticRenderFns } from "./ImsJobRolesWidget.vue?vue&type=template&id=f0d3e232"
import script from "./ImsJobRolesWidget.vue?vue&type=script&lang=js"
export * from "./ImsJobRolesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports